/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import PortraitIcon from '@mui/icons-material/Portrait'; 
import WorkIcon from '@mui/icons-material/Work';
import EmailIcon from '@mui/icons-material/Email';
import GroupAddIcon from '@mui/icons-material/GroupAdd';

export interface User {
    firstname: string,
    lastname: string,
    fullName: string,
    company: Company
    userid: number,
    emailid: string,
    internaluser: string,
    status: boolean,
    userrolemapping: Array<UserRoleMapping>,
    userservicelevelmapping: Array<UserServiceLevelMapping>
}

export interface UserServiceLevelMapping {
  serviceLevel:ServiceLevel
}
export interface ServiceLevel {
  serviceLevelId: number,
  serviceLevelValue: number
}
export interface UserRoleMapping {
  userrole:UserRole
}
export interface UserRole {
  rolename: string,
  roleid: number,
  isInternalRole: boolean
  rolemodulemapping: Array<RoleModuleMapping>
}
export interface Company {
  companyname: string
}
export interface RoleModuleMapping {
  module: Module
}
export interface Module {
  id: number,
  modulename: string
}
export const userSearchSuggestions = [
  {
    Icon: PortraitIcon,
    toolTip: 'User Name',
    suffix: ' in User Name',
    searchProp: 'username'
  },
  {
    Icon: WorkIcon,
    toolTip: 'Company Name',
    suffix: ' in Company Name',
    searchProp: 'company'
  },
  {
    Icon: EmailIcon,
    toolTip: 'Email',
    suffix: ' in Email Id',
    searchProp: 'email'
  },
  {
    Icon: SupervisedUserCircleIcon,
    toolTip: 'User Type',
    suffix: ' in User Type',
    searchProp: 'usertype'
  }, {
    Icon: GroupAddIcon,
    toolTip: 'Roles',
    suffix: ' in Roles',
    searchProp: 'roles'
  }
]

export const userroleSearchSuggestions = [
  {
    Icon: GroupAddIcon,
    toolTip: 'User Role',
    suffix: ' in User Role',
    searchProp: 'userrole'
  },
  {
    Icon: WorkIcon,
    toolTip: 'Modules',
    suffix: ' in Modules',
    searchProp: 'modules'
  }
];
